import React, {Component} from 'react';
import "../../css/dashboard.css"
import MuiTable from "../components/MuiTable";
import axiosInstance from "../../axiosInstance";
import { Link, withRouter } from "react-router-dom";
import { containsPermission, logOut, make_select_data } from "../helper";
import Select from 'react-select';
import { Col, Form } from 'react-bootstrap';





const defaultValue =  { 
    value:0,
    label:'ყველა'
}
class Dashboard extends Component{

    constructor(){
        super();
        this.wrapper = React.createRef();
        this.state = {
            types_filters_array:[],
            status_filters_array:[],
            stages_filters_array:[],
            type_filter:0,
            status_filter:0,
            stage_filter:0,
            date_from : null,
            date_to : null
        }
    }


    componentDidMount(){
        this.fetch_filter_types();
        this.fetch_filter_statuses()
        this.fetch_filter_stages();
    }


    on_type_fetch(data){
        this.setState({
            types_filters_array:data
        })
    }
    fetch_filter_types(){
        axiosInstance.get('tickets/types/auth')
        .then(response=>{
            let types = make_select_data(response.data.data);
            types.unshift(defaultValue)
            this.setState({
                types_filters_array:types
            })
        })
        .catch(err => {
            if(err.response?.status == 401){
                logOut(this.props);
            }
        })
    }



    fetch_filter_stages(){
        axiosInstance.get('/tickets/stages/auth')
        .then(response=>{
            let stages = make_select_data(response.data.data);
            stages.unshift(defaultValue)
            this.setState({
                stages_filters_array:stages 
            })
        })
        .catch(err => {
            console.log(err)
            if(err.response){
                if(err.response.status === 401){
                    logOut(this.props);
                }
            }
        })
    }

    fetch_filter_statuses(){
        axiosInstance.get('/tickets/statuses')
        .then(response=>{
            let statuses = make_select_data(response.data.data);
            statuses.unshift(defaultValue);
            this.setState({
                status_filters_array:statuses
            })
        })
        .catch(err => {
            console.log(err)
            if(err.response){
                if(err.response.status === 401){
                    logOut(this.props);
                }
            }
        })
    }

    type_filter_changed(e){
        this.setState({
            type_filter:parseInt(e.value)
        })
    }

    status_filter_changed(e){
        this.setState({
            status_filter:parseInt(e.value)
        })
    }

    stage_filter_changed(e){
        this.setState({
            stage_filter:parseInt(e.value)
        })
    }

    startDateChanged(e){
        this.setState({
            date_from:e.target.value
        })
    }

    endDateChanged(e){
        this.setState({
            date_to:e.target.value
        })
    }
    


    render(){
                    
        let add_ticket = containsPermission(this.props.role_permissions,'tickets.add') ? <Link  to = "/dashboard/new_ticket"  id = "create_new_btn" className="btn btn-dark" >ახლის დამატება</Link> : null;
        return (
            <div className = "dashboard">
                <Form.Row>
                    <Form.Group as={Col} sm={12} md = {2}>
                        <Form.Label>ტიპი</Form.Label>
                        <Select 
                            menuContainerStyle={{ zIndex: 999 }}
                            maxMenuHeight={170} 
                            options={this.state.types_filters_array} 
                            onChange={(e)=>this.type_filter_changed(e)}
                            defaultValue ={defaultValue}
                        />
                        
                    </Form.Group>
                    <Form.Group as={Col} sm={12} md = {2}>
                        <Form.Label>სტატუსი</Form.Label>
                        <Select 
                            pageSize = {1}
                            maxMenuHeight={170}
                            options= {this.state.status_filters_array} 
                            onChange={(e)=>this.status_filter_changed(e)}
                            defaultValue ={defaultValue}
                            
                        />  
                    </Form.Group>
                    <Form.Group as={Col} sm={12} md = {2}>
                        <Form.Label>მდგომარეობა</Form.Label>
                        <Select
                            maxMenuHeight={170} 
                            options= {this.state.stages_filters_array} 
                            onChange={(e)=>this.stage_filter_changed(e)} 
                            defaultValue ={defaultValue}
                        />
                    </Form.Group>
                    <Form.Group as={Col} sm={12} md = {3}>
                        <label>საწყისი თარიღი</label>
                        <input type="date" className="form-control" onChange = {(e) => this.startDateChanged(e)}/>
                    </Form.Group>
                    <Form.Group as={Col} sm={12} md = {3}>
                        <label>საბოლოო თარიღი</label>
                        <input type="date" className="form-control" onChange = {(e) => this.endDateChanged(e)}/>
                    </Form.Group>
                </Form.Row>
                <div className = "datatable">
                    {add_ticket}
                    <MuiTable  
                    type_filter = {this.state.type_filter} 
                    status_filter = {this.state.status_filter}
                    stage_filter = {this.state.stage_filter}
                    date_from = {this.state.date_from}
                    date_to = {this.state.date_to}
                    role_permissions = {this.props.role_permissions}
                    />
                </div>
            </div>
        )
    }
}

export default withRouter(Dashboard)  